"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var ProjectTypes_1 = require("Project/ProjectTypes");
var ProjectTemplater = (function () {
    function ProjectTemplater(templates, showTemplateExplainer, useHistoryDataStore, notifyUser) {
        var _this = this;
        this.templates = templates;
        this.showTemplateExplainer = showTemplateExplainer;
        this.useHistoryDataStore = useHistoryDataStore;
        this.notifyUser = notifyUser;
        this.addAsTemplate = function (projectStore) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!lodash_1.default.includes([Types_1.ProjectStatus.Live, Types_1.ProjectStatus.Disabled], projectStore.status)) return [3, 2];
                        return [4, projectStore.setStatus({ status: Types_1.ProjectStatus.Draft })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4, projectStore.setSpringboardSettings({ engagementMenuEnabled: true, contactPageOwnerEnabled: true })];
                    case 3:
                        _a.sent();
                        return [4, projectStore.disableLinkSecurity()];
                    case 4:
                        _a.sent();
                        return [4, projectStore.addTag(ProjectTypes_1.SpecialProjectTag.Template)];
                    case 5:
                        _a.sent();
                        return [4, projectStore.moveToFolder(null)];
                    case 6:
                        _a.sent();
                        this.notifyUser.success("Page marked as template");
                        this.addToTemplatesLibrary(projectStore);
                        this.maybeShowTemplateExplainer();
                        return [2];
                }
            });
        }); };
        this.removeAsTemplate = function (projectStore) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, projectStore.removeTag(ProjectTypes_1.SpecialProjectTag.Template)];
                    case 1:
                        _a.sent();
                        this.notifyUser.success("Page removed as template");
                        this.removeFromTemplateLibrary(projectStore);
                        return [2];
                }
            });
        }); };
    }
    ProjectTemplater.prototype.isTemplate = function (project) {
        return lodash_1.default.includes(project.tags, ProjectTypes_1.SpecialProjectTag.Template);
    };
    ProjectTemplater.prototype.addToTemplatesLibrary = function (projectStore) {
        if (this.templates.library != null) {
            this.templates.library.push({
                name: projectStore.name,
                category: "My Templates",
                categories: [],
                projectId: projectStore._id,
                secret: projectStore.links[0].secret,
                image: "/Assets/Images/template-placeholder.jpg",
                crmInfo: projectStore.crmInfo,
                isAccountTemplate: true,
                $userAction: projectStore.userAction,
            });
        }
    };
    ProjectTemplater.prototype.removeFromTemplateLibrary = function (projectStore) {
        if (this.templates.library != null) {
            lodash_1.default.remove(this.templates.library, { secret: projectStore.links[0].secret });
        }
    };
    ProjectTemplater.prototype.maybeShowTemplateExplainer = function () {
        if (this.useHistoryDataStore.shouldShowTemplateExplainer) {
            this.showTemplateExplainer();
            this.useHistoryDataStore.viewedTemplateExplainer();
        }
    };
    return ProjectTemplater;
}());
exports.default = ProjectTemplater;
